import { useContext } from "react";
import { Navigate } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import routes from "../../common/browserRoutes";
import { DP, ITopic } from "../../common/types";
import { createFormValidation } from "../../context/createFormValidation";
import { createCustomStore } from "../../context/customStore";
import { ProfileContext } from "../../context/profileContext";
import { defaultValidateRules, IRules } from "../../hooks/useFormValidation";
import { setLoginStore } from "../../sections/Login";
import CloudinaryUploadButton from "./components/CloudinaryUploadButton";
import Input from "./components/Input";
import SubmitButton from "./components/SubmitButton";
import TopicsInput from "./components/TopicsInput";
import VideoInput from "./components/VideoInput";

const rules: IRules<IInitFields> = {
  title: [defaultValidateRules.setMinLength(4), defaultValidateRules.setMaxLength(50)],
  videoId: [defaultValidateRules.required()],
  topics: [
    {
      isValid: (arr: any[]) => !!arr.length,
      errorMessage: "At least 1 topic required",
    },
  ],
};
 

export interface IInitFields {
  title?: string;
  videoId?: string;
  topics: ITopic[];
}

const initFields: IInitFields = {
  title: "",
  videoId: undefined,
  topics: [],
};

export const {
  useFieldError,
  useFieldValue,
  getFields,
  setField,
  isFieldsValid,
  resetFormFields,
} = createFormValidation(initFields, rules);

interface IContext {
  reqestProgress: number;
	isVideoUploaded: boolean;
  isLoading: boolean;
	thumbnail_url?: string;
}

export const { useValue: useCreatePostStore, set: setCreatePostStore, get: getCreatePostStore } =
  createCustomStore<IContext>({ isLoading: false, reqestProgress: 0, isVideoUploaded: false });

const CreatePost = (props: DP) => {
  const isLoading = useCreatePostStore((s) => s.isLoading);
  const profile = useContext(ProfileContext);

  if (!profile) {
    setLoginStore({ loginFormVisibility: true });
    return <Navigate to={routes.index()} />;
  }

  return (
    <Wrapper>
      <Header>Create post</Header>
      <Form>
        <Input disabled={isLoading} />
        <TopicsInput disabled={isLoading} />
				<CloudinaryUploadButton disabled={isLoading} />
        <SubmitButton disabled={isLoading} />
      </Form>
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
  tw`flex flex-col items-center mt-1 space-y-2 text-pink-600 `,
]);

const Header = styled.h1(() => [tw`font-bold`]);

const Form = styled.form(() => [
  tw`flex flex-col space-y-2`,
  css`
    margin: 0 auto;
    width: max(15rem, 40%);
  `,
]);

export default styled(CreatePost)``;
